import { useEffect, useState } from "react";
import { portfolioList } from "@/lib/api";

export const PORTFOLIO_CATEGORIES = [
  ["graduation", "Graduation"],
  ["birthdays", "Children's Birthdays"],
  ["apparel", "Custom Apparel"],
  ["drinkware", "Drinkware"],
  ["party_favors", "Party Favors"],
  ["signage", "Signage & Backdrops"],
  ["labels", "Labels & Stickers"],
  ["other", "Other Custom Creations"],
];
export const CATEGORY_LABEL = Object.fromEntries(PORTFOLIO_CATEGORIES);

// Which catalog block shows a photo's example when "Also show in catalog" is on.
export const CATALOG_SPOT = {
  graduation: "graduation", birthdays: "birthday", labels: "labels",
  apparel: "ready", drinkware: "ready", party_favors: "ready", signage: "ready", other: "ready",
};

export const EXAMPLE_NOTE = "Photos shown are examples of previous custom work. Your design will be customized for your order.";

const VALID = new Set(PORTFOLIO_CATEGORIES.map(([k]) => k));
const clean = (d) => (Array.isArray(d) ? d : [])
  .filter((p) => p && typeof p === "object" && typeof p.id === "string" && p.id)
  .map((p) => ({ ...p, category: VALID.has(p.category) ? p.category : "other", caption: typeof p.caption === "string" ? p.caption : "" }));

let pending = null;
export const usePortfolio = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    let alive = true;
    pending = pending || portfolioList().finally(() => { setTimeout(() => { pending = null; }, 0); });
    pending.then((d) => { if (alive) setItems(clean(d)); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return items;
};
